import React from 'react';
import PropTypes from 'prop-types';

import {connect} from 'react-redux';

import {completeEmailOAuth, completeOAuth} from '../../../ducks/auth';
import asSubmissionError from '../../../utils/asSubmissionError';

import {browserHistory} from 'react-router';

import Loader from '../../../components/loader/Loader';
import ErrorPage from '../../errorPage/ErrorPage';
import OAuthEmailForm from '../../../components/auth/OAuthEmailForm';
import OAuthTOSForm from '../../../components/auth/OAuthTOSForm';
import {updateUserProfile} from '../../../ducks/user';
import {FormattedMessage} from 'react-intl';
import withChannelFormatters from '../../channelUtils/withChannelFormatters';

@withChannelFormatters
@connect(({user}) => ({profile: user.profile}))
export default class OAuthHandlerPage extends React.PureComponent {
  static STEP_TOKEN_CONSUMPTION = 'STEP_TOKEN_CONSUMPTION';
  static STEP_EMAIL_REQUIRED = 'STEP_EMAIL_REQUIRED';
  static STEP_AUTHORIZED = 'STEP_AUTHORIZED';
  static STEP_ERROR = 'STEP_ERROR';

  constructor(props) {
    super(props);

    this.state = {
      step: OAuthHandlerPage.STEP_TOKEN_CONSUMPTION,
      serviceToken: null
    };
  }

  completeEmailOAuth = ({email}) => {
    const {dispatch} = this.props;
    const {serviceToken} = this.state;

    return dispatch(completeEmailOAuth(serviceToken, email))
      .catch(asSubmissionError)
      .then(() => this.setState({step: OAuthHandlerPage.STEP_AUTHORIZED}))
  };

  acceptTos = ({tosAccepted, newsletterSubscribed}) => {
    const {dispatch, profile} = this.props;

    return dispatch(updateUserProfile({
      username: profile.username,
      email: profile.email,
      skypeUsername: profile.skypeUsername || '',
      discordUsername: profile.discordUsername || '',
      tosAccepted,
      newsletterSubscribed
    }))
      .then(() => this.setState({step: OAuthHandlerPage.STEP_AUTHORIZED}))
      .catch(asSubmissionError);
  };

  componentDidMount() {
    const {profile} = this.props;
    if (profile) {
      return this.setState({step: OAuthHandlerPage.STEP_AUTHORIZED});
    }

    const serviceToken = localStorage.getItem('oAuthToken');
    localStorage.removeItem('oAuthToken');

    if (!serviceToken) {
      return this.setState({step: OAuthHandlerPage.STEP_ERROR});
    }

    this.setState({serviceToken});

    this.props.dispatch(completeOAuth(serviceToken))
      .then(
        () => this.setState({step: OAuthHandlerPage.STEP_AUTHORIZED}),
        error => this.setState({
          step: error.stateDetails === 'Users email input required.'
            ? OAuthHandlerPage.STEP_EMAIL_REQUIRED
            : OAuthHandlerPage.STEP_ERROR
        })
      );
  }

  componentDidUpdate(prevProps, prevState) {
    const {profile, channelFormatters} = this.props;

    if ((profile && profile.tosAccepted) && prevProps.profile !== profile) {
      browserHistory.push(channelFormatters.link('/profile'));
    }
  }

  render() {
    const {profile} = this.props;
    const {step} = this.state;

    if (step === OAuthHandlerPage.STEP_ERROR) {
      return <ErrorPage type={ErrorPage.serviceUnavailable}/>;
    }

    if (step === OAuthHandlerPage.STEP_EMAIL_REQUIRED) {
      return (
        <div className="page-auth">
          <div className="modal-overlay modal--page">
            <div className="modal">
              <div className="modal__content">
                <div className="modal__column">
                  <div className="modal__header">
                    <FormattedMessage id="section.auth.confirm-email"/>
                  </div>
                  <OAuthEmailForm onSubmit={this.completeEmailOAuth}/>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    if (step === OAuthHandlerPage.STEP_AUTHORIZED && (profile && !profile.tosAccepted)) {
      return (
        <div className="page-auth">
          <div className="modal-overlay modal--page">
            <div className="modal">
              <div className="modal__content">
                <div className="modal__column">
                  <div className="modal__header">Sign Up</div>
                  <OAuthTOSForm onSubmit={this.acceptTos}/>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return <Loader page/>;
  }
}



// WEBPACK FOOTER //
// ./containers/auth/pages/OAuthHandlerPage.js